import { Modal } from 'bootstrap';

export default () => {
  const applyJobButtons = document.querySelectorAll('[data-action="apply-job"]');
  if (applyJobButtons) {
    applyJobButtons.forEach((button) => {
      const jobModalElement: HTMLElement | null = document.querySelector('#jobFormModal');
      if (!jobModalElement) return;
      const jobModal = jobModalElement ? new Modal(jobModalElement) : null;
      const postId = button.getAttribute('data-post-id');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const jobField = jobModalElement.querySelector('select[name="job"]') as HTMLSelectElement | null;
        if (jobField !== null && postId) {
          jobField.value = postId;
          jobField.parentElement?.classList.add('d-none');
        }
        jobModal?.show();

        jobModalElement.querySelector('.btn-close')?.addEventListener('click', () => {
          jobModal?.hide();
        });
      });
    });
  }
};
